import { gql } from "@apollo/client";

export const SEND_SINGLE_NMI_B_TRANSACTION = gql`
  mutation sendSingleNMI_B_Transaction(
    $token: String!
    $paymentdata: CustomerPayment!
  ) {
    sendSingleNMI_B_Transaction(token: $token, paymentdata: $paymentdata) {
      status
      data
      error
    }
  }
`;

export const SEND_NMI_B_VERIFICATION_TRANSACTIONS = gql`
  mutation sendNMI_B_VerificationTransactions($phone: String!) {
    sendNMI_B_VerificationTransactions(phone: $phone) {
      status
      data
      error
    }
  }
`;

export const CONFIRM_NMI_B_VERIFICATION_TRANSACTIONS = gql`
  mutation verifyTempNMI_B_Transactions($phone: String!, $amount1: Float!) {
    verifyTempNMI_B_Transactions(phone: $phone, amount1: $amount1) {
      status
      data
      error
    }
  }
`;
